export default {
    // !important overrides Chakra's default 8rem menu minimum width, keeping the list aligned with the input.
    menuListRoot: {width: '100%', minWidth: '0 !important'},
    menuListMotion: {
        variants: {
            enter: {
                opacity: 1,
                scaleY: 1,
                transition: {duration: 0.2, ease: 'easeOut'},
                visibility: 'visible'
            },
            exit: {
                opacity: 0,
                scaleY: 0,
                transition: {duration: 0.1, ease: 'easeOut'},
                transitionEnd: {visibility: 'hidden'}
            }
        }
    },
    countrySelector: {
        height: 'var(--phone-input-height)',
        pointerEvents: 'auto',
        paddingLeft: 2
    },
    countrySelectorContent: {
        alignItems: 'center',
        display: 'flex',
        gap: 2
    },
    countrySelectorIndicator: {
        backgroundColor: 'stokkeCore.black',
        clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
        flexShrink: 0,
        height: 2,
        marginInlineStart: 1,
        transition: 'transform 0.2s',
        width: 3,
        '&[data-open="true"]': {
            transform: 'rotate(180deg)'
        }
    },
    inputGroup: {
        '--phone-input-height': '3.6875rem',
        '--gap-selector-input': '0.75rem',
        alignItems: 'center',
        borderBottom: '0.125rem solid',
        borderColor: 'stokkeCore.black',
        backgroundColor: 'stokkeCore.white',
        display: 'grid',
        columnGap: 'var(--gap-selector-input)',
        gridTemplateColumns: 'max-content minmax(0, 1fr)',
        position: 'relative',
        _invalid: {
            borderColor: 'stokkeFunctional.alertRed'
        },
        // Field does not expose props for styling the left-element wrapper.
        '& > .chakra-input__left-element': {
            gridColumn: 1,
            position: 'static'
        },
        '& > .chakra-input': {
            // This selector outranks the flushed input variant's bottom border.
            borderBottomWidth: 0
        }
    },
    input: {
        height: 'var(--phone-input-height)',
        paddingInlineEnd: 12,
        gridColumn: 2,
        minWidth: 0,
        paddingInlineStart: 2,
        _focus: {
            borderWidth: 0
        },
        _focusVisible: {
            borderWidth: 0
        },
        _invalid: {
            borderWidth: 0
        }
    },
    menuList: {
        width: '100%',
        backgroundColor: 'stokkeCore.white',
        borderColor: 'stokkeCore.black',
        borderRadius: 0,
        paddingBlock: 2,
        borderTopWidth: '0.125rem',
        boxShadow: 'none',
        marginTop: 0,
        maxHeight: '29rem',
        overflowY: 'auto',
        zIndex: 'dropdown',
        '&::-webkit-scrollbar': {
            width: '1.125rem'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundClip: 'content-box',
            backgroundColor: 'stokkeCore.black',
            borderInline: '0.5rem solid transparent',
            borderTop: '0.5rem solid transparent'
        },
        '&::-webkit-scrollbar-track': {
            backgroundClip: 'content-box',
            backgroundColor: 'stokkeGray.mid',
            borderInline: '0.5rem solid transparent',
            borderTop: '0.5rem solid transparent'
        },
        '& > .chakra-menu__menuitem': {
            paddingLeft: 2
        }
    },
    countryOption: {
        alignItems: 'center',
        minHeight: 16,
        '&[aria-current="true"]': {
            backgroundColor: 'stokkeGray.bright'
        },
        _focus: {
            backgroundColor: 'stokkeGray.bright'
        },
        _hover: {
            backgroundColor: 'stokkeGray.mid'
        }
    },
    countryFlag: {
        boxSize: 3,
        flexShrink: 0
    },
    countryDialCode: {
        flexShrink: 0,
        marginInlineStart: 2
    },
    countryName: {
        marginInlineStart: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
}
